<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-top" to="/">
      <CIcon
        src="dcs_logo.png"
        class="c-sidebar-brand-full"
        name="logo"
        size="custom-size"
        :height="35"
        viewBox="0 0 556 134"
      />
      <CIcon
        class="c-sidebar-brand-minimized"
        name="logo"
        size="custom-size"
        :height="35"
        viewBox="0 0 110 134"
      />
    </CSidebarBrand>

    <CRenderFunction :contentToRender="computedSidebar" flat />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import Nav from "./_nav";
//import coreuiNav from './_nav_coreUI'
import constOperationAuthority from "../../definition/const/const_operation_authority";
import constPage from "../../definition/const/const_page";
export default {
  name: "TheSidebar",
  data() {
    return {
      isCareers: true,
      isUser: true,
      isOrganization: true,
      isPosition: true,
      isAuthority: true,
      isSkill: true,
      isQualification: true,
      isMaster: true,
      isQualificationInfo: true,
      isSkillInfo: true,
      authorities: [],
    };
  },
  computed: {
    currentItems() {
      var navItems = [];
      var masterItem = [];
      let Count = 0;

      //#region  閲覧権限処理
      var authorities = this.$store.state.loginUser.p_authorities;
      if (!authorities) {
        return;
      }
      //各権限取得
      authorities.forEach((authority) => {
        //経歴一覧権限チェック
        if (
          authority.page_id == constPage.CAREERS &&
          authority.operation_authority <
            constOperationAuthority.VIEW_SUBORDINATE
        ) {
          this.isCareers = false;
        }
        //個人資格情報一覧権限チェック
        if (
          authority.page_id == constPage.QUALIFICATIONINFO &&
          authority.operation_authority == constOperationAuthority.NONE
        ) {
          this.isQualificationInfo = false;
        }
        //個人スキル情報一覧権限チェック
        if (
          authority.page_id == constPage.SKILLINFO &&
          authority.operation_authority == constOperationAuthority.NONE
        ) {
          this.isSkillInfo = false;
        }
        //ユーザー一覧権限チェック
        if (
          authority.page_id == constPage.USER_MASTER &&
          authority.operation_authority == constOperationAuthority.NONE
        ) {
          this.isUser = false;
          Count++;
        }
        //組織マスタ一覧権限チェック
        if (
          authority.page_id == constPage.ORGANIZATION_MASTER &&
          authority.operation_authority == constOperationAuthority.NONE
        ) {
          this.isOrganization = false;
          Count++;
        }
        //役職マスタ一覧権限チェック
        if (
          authority.page_id == constPage.POSITION_MASTER &&
          authority.operation_authority == constOperationAuthority.NONE
        ) {
          this.isPosition = false;
          Count++;
        }
        //閲覧権限マスタ一覧権限チェック
        if (
          authority.page_id == constPage.AUTHORITY_MASTER &&
          authority.operation_authority == constOperationAuthority.NONE
        ) {
          this.isAuthority = false;
          Count++;
        }
        //スキルマスタ一覧権限チェック
        if (
          authority.page_id == constPage.SKILL_MASTER &&
          authority.operation_authority == constOperationAuthority.NONE
        ) {
          this.isSkill = false;
          Count++;
        }
        //資格マスタ一覧権限チェック
        if (
          authority.page_id == constPage.QUALIFICATION_MASTER &&
          authority.operation_authority == constOperationAuthority.NONE
        ) {
          this.isQualification = false;
          Count++;
        }
      });
      //マスタメンテナンスメニュー権限チェック
      if (Count == 6) {
        this.isMaster = false;
      }
      //#endregion

      //#region  メニュー取得処理

      //メインメニュー追加
      navItems.push(Nav.main);
      //プロフィールメニュー追加
      navItems.push(Nav.profile);

      //経歴メニュー追加
      if (this.isCareers == true) {
        navItems.push(Nav.careers);
      }

      //個人資格情報メニュー追加
      if (this.isQualificationInfo == true) {
        navItems.push(Nav.qualification);
      }

      //個人スキル情報メニュー追加
      if (this.isSkillInfo == true) {
        navItems.push(Nav.skillinfo);
      }

      //マスタメンテナンスメニュー部追加
      if (this.isMaster == true) {
        masterItem.push(Nav.master);
        //マスタメンテナンスメニュー初期化
        Nav.master.items = [];

        if (this.isUser == true) {
          masterItem[0].items.push(Nav.user);
        }
        //役職メニュー追加
        if (this.isOrganization == true) {
          masterItem[0].items.push(Nav.positions);
        }
        //組織メニュー追加
        if (this.isPosition == true) {
          masterItem[0].items.push(Nav.organizations);
        }
        //スキルメニュー追加
        if (this.isSkill == true) {
          masterItem[0].items.push(Nav.skills);
        }
        //資格メニュー追加
        if (this.isQualification == true) {
          masterItem[0].items.push(Nav.qualifications);
        }
        //閲覧権限メニュー追加
        if (this.isAuthority == true) {
          masterItem[0].items.push(Nav.authorities);
        }
        masterItem.forEach((master) => {
          navItems.push(master);
        });
      }

      /*   //coreUIメニュー部追加
      coreuiNav.forEach((coreUI) => {
        navItems.push(coreUI);
      }); */

      //#endregion

      return navItems;
    },
    computedSidebar() {
      return [
        {
          _name: "CSidebarNav",
          _children: this.currentItems,
        },
      ];
    },
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },
};
</script>

<style scoped>
.d-md-down-top {
  background-color: white;
}
</style>